export class GetWorkOrdersRequest {
  User: string;
  Environment: NonNullable<"LIVE" | "TEST" | "DEV" | "LOCAL" | "">;
  ConveyanceID?: number;
  IncludeMetadata: string[];
  OlderThan?: Date;
  NewerThan?: Date;
}
